<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.leaveType != null ? data.sysText.employerLeaveTypes_edit : data.sysText.employerLeaveTypes_add }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-input-field
      [control]="form.controls.name"
      [isDisabled]="true"
      [icon]="'business'"
      [label]="data.sysText.employerLeaveTypes_name"
      [inputType]="'string'">
    </app-input-field>
    <app-select-field
      [control]="form.controls.leaveCategory"
      [label]="data.sysText.employerLeaveTypes_category"
      [options]="data.dialogOptions.leaveCategories"
      [icon]="'business_center'"
      [shouldCapitalize]="false">
    </app-select-field>
    <app-multi-select-field
      [control]="form.controls.banks"
      [label]="data.sysText.employerLeaveTypes_eb"
      [options]="bankOptions"
      [icon]="'move_to_inbox'"
      [shouldCapitalize]="false">
    </app-multi-select-field>
    <div class="slide-container padding">
      <app-slide-toggle
        [control]="form.controls.leavesRequireAllBankHours"
        [icon]="'done_all'"
        [capitalizeLabel]="false"
        [label]="data.sysText.employerLeaveTypes_leavesRequireAllBankHours">
      </app-slide-toggle>
    </div>
    <app-multi-select-field
      [control]="form.controls.buckets"
      [label]="data.sysText.employerLeaveTypes_neb"
      [options]="bucketOptions"
      [icon]="'move_to_inbox'"
      [shouldCapitalize]="false">
    </app-multi-select-field>
    <app-select-field
      [control]="form.controls.leaveSchedule"
      [label]="data.sysText.employerLeaveTypes_schedule"
      [options]="leaveScheduleOptions"
      [showBlankOption]="true"
      [icon]="'calendar_today'"
      [shouldCapitalize]="false">
    </app-select-field>
    <div class="slide-container margin-left">
      <app-slide-toggle
        [control]="form.controls.allowUse"
        [capitalizeLabel]="false"
        [label]="data.sysText.employerLeaveTypes_allowUse">
      </app-slide-toggle>
    </div>
  </form>
  @if (this.form.errors?.msError) {
    <mat-error class="mse-form-error caption">{{ this.form.errors?.msError }}</mat-error>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="close(false)">
      {{data.sysText.cancel}}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && onSubmit()">
    {{data.sysText.save}}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

